import * as d3 from "d3";

export const getContainerDimensions = (
  svg: d3.Selection<SVGSVGElement, unknown, HTMLElement, any>,
  plotClassName: string,
) => {
  const parentNode = svg.node()?.parentNode as HTMLElement;
  const parentWidth = parentNode?.clientWidth;
  const parentHeight = parentNode?.clientHeight;

  if (parentWidth && parentHeight) {
    return {
      containerWidth: parentWidth,
      containerHeight: parentHeight,
    };
  }

  const plotContainer = d3.select(`div.${plotClassName}`) as d3.Selection<
    HTMLDivElement,
    unknown,
    HTMLElement,
    any
  >;

  const plotWidth = plotContainer.node()?.clientWidth;
  const plotHeight = plotContainer.node()?.clientHeight;

  if (plotWidth && plotHeight) {
    return {
      containerWidth: plotWidth,
      containerHeight: plotHeight,
    };
  }

  const svgWidth = svg.node()?.clientWidth;
  const svgHeight = svg.node()?.clientHeight;

  if (svgWidth && svgHeight) {
    return {
      containerWidth: svgWidth,
      containerHeight: svgHeight,
    };
  }

  const widthFromViewBox = svg.node()?.viewBox?.baseVal?.width;
  const heightFromViewBox = svg.node()?.viewBox?.baseVal?.height;
  if (widthFromViewBox && heightFromViewBox) {
    return {
      containerWidth: widthFromViewBox,
      containerHeight: heightFromViewBox,
    };
  }
  return {
    containerWidth: 0,
    containerHeight: 0,
  };
};
